module.exports = __webpack_public_path__ + "img/pricing.2dd11f34.svg";